import { createTheme } from '@material-ui/core/styles';

const theme = createTheme({
    palette: {
        primary: {
            main: '#002246'
        },

        secondary: {
            main: '#bfc0c1'
        },

        error: {
            main: '#f44336'
        },

        warning: {
            main: '#ff9800'
        },

        info: {
            main: '#2196f3'
        },

        success: {
            main: '#4caf50'
        }
    },

    typography: {
        fontFamily: [
            'Lato',
            'Helvetica Neue',
            'Arial',
            'Helvetica',
            'sans-serif'
        ].join(',')
    },

    overrides: {
        MuiButton: {
            root: {
                textTransform: 'none'
            }
        },
        MuiTooltip: {
            tooltip: {
                fontSize: '1em'
            }
        },
        MuiDataGrid: {
            root: {
                '& .MuiDataGrid-window': {
                    overflowX: 'hidden'
                }
            }
        }
    }
});

export default theme;
